import { OrganizationScope } from "~/hooks/useScope";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Home as HomeIcon } from "@mui/icons-material";
import { PoliciesAddDetailPage } from "~/pages/shared/policy/PoliciesAddDetailPage";

export type OrganizationPoliciesAddDetailPageProps = {
  scope: OrganizationScope;
};

export function OrganizationPoliciesAddDetailPage({
  scope,
}: OrganizationPoliciesAddDetailPageProps) {
  return (
    <PoliciesAddDetailPage
      scope={scope}
      basePath="/organization/policies"
      sectionLabel="Organization Policies"
      renderBreadcrumbs={(policyName) => (
        <Breadcrumbs sx={{ mb: 3, overflowWrap: "anywhere" }} separator="›">
          <Link
            key="/dashboard"
            component={RouterLink}
            to={`/dashboard`}
            display="flex"
          >
            <HomeIcon fontSize="inherit" />
          </Link>
          <Link
            key="/organization/policies"
            component={RouterLink}
            to={`/organization/policies?${scope.params}`}
          >
            Organization Policies
          </Link>
          <Link
            key="/organization/policies/add"
            component={RouterLink}
            to={`/organization/policies/add?${scope.params}`}
          >
            Add Policies
          </Link>
          <Typography key="/organization/policies/add/policyId">
            {policyName}
          </Typography>
        </Breadcrumbs>
      )}
    />
  );
}
